import * as React from 'react'
import './NotationLayer.scss'
import { inject, observer } from 'mobx-react'
import RootStore from '../../../stores/RootStore'
import { NotationBox } from '@tfo/common'

interface NotationLayerProps {
	rootStore?: RootStore
}

class NotationLayer extends React.Component<
	React.HTMLAttributes<HTMLDivElement> & NotationLayerProps
> {
	private resizeListener: EventListener
	private touchStartListener: EventListener
	private mouseMoveListener: EventListener
	private scrollListener: EventListener
	public readonly store: RootStore

	constructor(props: NotationLayerProps) {
		super(props)
		this.store = props.rootStore!
	}

	componentDidMount(): void {
		this.resizeListener = this.onResize.bind(this)
		this.mouseMoveListener = this.onMouseMove.bind(this)
		this.touchStartListener = this.onMouseMove.bind(this)
		this.scrollListener = this.onScroll.bind(this)
		window.addEventListener('resize', this.resizeListener)
		window.addEventListener('touchstart', this.touchStartListener)
		window.addEventListener('mousemove', this.mouseMoveListener)
		window.addEventListener('scroll', this.scrollListener)
		this.handleResize()
	}
	componentWillUnmount(): void {
		window.removeEventListener('resize', this.resizeListener)
		window.removeEventListener('mousemove', this.mouseMoveListener)
		window.removeEventListener('scroll', this.scrollListener)
	}
	onScroll() {
		this.handleResize()
	}
	onResize() {
		this.handleResize()
	}
	handleResize() {
		this.store.notationStore.clear()
	}
	onMouseMove(e: any) {
		if (
			e.target &&
			!(e.target as HTMLElement).classList.contains('NotationButton')
		) {
			this.store.notationStore.clear()
		}
	}
	getStyle(): any {
		if (!this.store.notationStore.anchorObj) {
			return
		}
		const box = document.querySelector(
			'.NotationLayer .NotationBox',
		) as HTMLDivElement
		const boxContent = document.querySelector(
			'.NotationBox__Content',
		) as HTMLDivElement
		if (!boxContent || !box) {
			return
		}
		const buttonRect = this.store.notationStore.anchorObj.getBoundingClientRect()
		box.style.left =
			'calc(' +
			Math.min(window.innerWidth, Math.max(0, buttonRect.left)) +
			'px - 17.9rem * .5 + 2rem)'
		box.style.top = '' + (buttonRect.top + buttonRect.height - 5) + 'px'
		boxContent.style.transform = ''

		const boxRect = box.getBoundingClientRect()
		const halfW = boxRect.width * 0.5
		const diff = Math.min(halfW, boxRect.left - boxRect.width * 0.5)
		const diff2 = Math.min(halfW - 10, boxRect.right - (window.innerWidth - 10)) // + (boxRect.width * 0.5);
		if (diff < 10) {
			boxContent.style.transform = 'translateX(' + -diff * 0.5 + 'px)'
		} else if (diff2 > 0) {
			boxContent.style.transform = 'translateX(' + -diff2 + 'px)'
		}
	}
	componentDidUpdate(): void {
		this.getStyle()
	}

	render() {
		const { anchorObj, title, body } = this.store.notationStore
		const rect = anchorObj && anchorObj.getBoundingClientRect()

		return (
			<div className={'NotationLayer'}>
				{anchorObj && rect && <NotationBox body={body} title={title} />}
			</div>
		)
	}
}
export default inject('rootStore')(observer(NotationLayer))
